import { DAYS, DAYS_SHORT, MONTHS, MONTHS_SHORT } from "@shared/constants/time/months";

//Ср, 4 Ноября
export function formatTime_dn_dnum_mn(dateString) {
  if (!dateString) return undefined;

  const months = MONTHS.map(str => str.charAt(0).toUpperCase() + str.slice(1))
  const [year, month, day] = dateString.split('-');
  const dateObject = new Date(dateString);
  const dayOfWeekIndex = (dateObject.getDay() + 6) % 7;
  const dayOfWeek = DAYS_SHORT[dayOfWeekIndex];
  const formattedDay = day.replace(/^0+/, '');
  const monthName = months[parseInt(month, 10) - 1];

  const formattedDate = `${dayOfWeek}, ${formattedDay} ${monthName}`;
  return formattedDate;
}

//4 Ноября
export function formatTime_dnum_mn(timestamp) {
  if (!timestamp) return undefined;
  const months = MONTHS.map(str => str.charAt(0).toUpperCase() + str.slice(1))
  const dateObject = new Date(timestamp);
  if (isNaN(dateObject)) return undefined;
  const day = dateObject.getDate();
  const monthName = months[dateObject.getMonth()];
  return `${day} ${monthName}`;
}

//Среда
export function formatTime_dweek(timestamp) {
  if (!timestamp) return undefined;
  const dateObject = new Date(timestamp);
  const dayOfWeekIndex = (dateObject.getDay() + 6) % 7;
  const dayOfWeek = DAYS[dayOfWeekIndex];
  return `${dayOfWeek}`;
}

//00:00
export function formatTime_h_min(timestamp) {
  if(!timestamp) return undefined;
  const time = new Date(timestamp);

  const hours = time.getHours().toString().padStart(2, '0');
  const minutes = time.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
}

//10 ноября 2024 21:29
export function formatTime_dn_mn_y_h_min(timestamp){
  if(!timestamp) return undefined;
  const options = { hour: '2-digit', minute: '2-digit' };
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = date.getMonth();
  const formattedTime = date.toLocaleTimeString('ru-RU', options);
  const year = date.getFullYear();
  return `${day} ${MONTHS[month]} ${year} ${formattedTime}`;
}

//10 ноября, 2024
export function formatTime_dn_mn_y(timestamp){
  if(!timestamp) return undefined;
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  return `${day} ${MONTHS[month]}, ${year}`;
}

//10 ноября, 17:00
export function formatTime_dn_h(timestamp){
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = MONTHS[date.getMonth()];
  const time = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  return `${day} ${month}, ${time}`;
}

//10 ноя, 17:00
export function formatTime_dnShort_h(timestamp){
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = MONTHS_SHORT[date.getMonth()];
  const time = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  return `${day} ${month}, ${time}`;
}


//10 ноя
export function formatTime_dn_mn(timestamp){
  if(!timestamp) return undefined;
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = date.getMonth();

  return `${day} ${MONTHS_SHORT[month]}`;
}

//2023-12-07
export function formatTime_yn_mn_dn(timestamp){
  const inputDate = new Date(timestamp);
  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, '0');
  const day = String(inputDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

//20:14, 10 ноября
export function formatTime_h_min_dn(inputDate) {
  const date = new Date(inputDate);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  const formattedDate = `${hours}:${minutes}, ${day} ${MONTHS[month]}`;
  return formattedDate;
}

//дек
export function formatTime_mShort(inputDate) {
  const date = new Date(inputDate);
  const month = date.getMonth();
  const formattedDate = `${MONTHS_SHORT[month]}`;
  return formattedDate;
}

//декабря
export function formatTime_mFull(inputDate) {
  const date = new Date(inputDate);
  const month = date.getMonth();
  const formattedDate = `${MONTHS[month]}`;
  return formattedDate;
}

//(число месяца)
export function formatTime_dayNumber(inputDate) {
  const date = new Date(inputDate);
  const day = date.getDate();
  const formattedDate = `${day}`;
  return formattedDate;
}

//Время назад
export function formatTime_timeAgo(utcDate) {
  const now = new Date();
  const date = new Date(utcDate);
  const diffInSeconds = Math.floor((now - date) / 1000);
  
  const intervals = {
    год: 31536000,
    месяц: 2592000,
    неделя: 604800,
    день: 86400,
    час: 3600,
    минута: 60
  };
  
  for (const [unit, seconds] of Object.entries(intervals)) {
    const interval = Math.floor(diffInSeconds / seconds);
    
    if (interval >= 1) {
      if (unit === 'день') {
        return interval === 1 ? '1д назад' : `${interval}д назад`;
      }
      
      return interval === 1 
        ? `1 ${unit} назад` 
        : `${interval} ${unit}${unit === 'месяц' ? 'а' : unit === 'год' ? '' : 'ов'} назад`;
    }
  }
  
  return 'только что';
}

//------------------------------------------------------------

// Для последних постов форкастеров
// 2w || 2d || 2y
export function timeForecastAgo(date) {
  const now = new Date();
  const postDate = new Date(date);
  const diffInSeconds = Math.floor((now - postDate) / 1000);

  const minutes = Math.floor(diffInSeconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);

  if (years > 0) return `${years}y`;
  if (months > 0) return `${months}m`;
  if (weeks > 0) return `${weeks}w`;
  if (days > 0) return `${days}d`;
  if (hours > 0) return `${hours}h`;
  if (minutes > 0) return `${minutes}m`;
  return `${diffInSeconds}s`;
}

// Для постов форкастеров форматирование даты
// 26.09.2024 11:58
export function formattedForecastCreationDate(date) {
  const dateCheck = typeof date === 'string'
      ? new Date(date)
      : date;

  const formattedDate = dateCheck.toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  });

  const formattedTime = dateCheck.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit'
  });

  return `${formattedDate} ${formattedTime}`;
}

// 24 окт
export function formatDayAndMonth(dateString) {
  if (!dateString) return undefined;

  const monthsShort = [
    'янв', 'фев', 'мар',
    'апр', 'май', 'июн',
    'июл', 'авг', 'сен',
    'окт', 'ноя', 'дек'
  ];

  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth();

  return `${day} ${monthsShort[month]}`;
}


// 24 окт.
export function formatDayAndMonthWithPoint(dateString) {
  if (!dateString) return undefined;

  const monthsShort = [
    'янв', 'фев', 'мар',
    'апр', 'май', 'июн',
    'июл', 'авг', 'сен',
    'окт', 'ноя', 'дек'
  ];

  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth();

  return `${day} ${monthsShort[month]}.`;
}

//----------------------------------------------------------------
//Форматирование дат в диапазон (6 янв - 6 июн)
const monthShortRu = [
  'янв', 'фев', 'мар', 'апр', 'май', 'июн',
  'июл', 'авг', 'сен', 'окт', 'ноя', 'дек',
];

export function formatDateRangeShort(startUtc, endUtc) {
  const start = new Date(startUtc);
  const end = new Date(endUtc);

  const startDay = start.getUTCDate();
  const startMonth = monthShortRu[start.getUTCMonth()];

  const endDay = end.getUTCDate();
  const endMonth = monthShortRu[end.getUTCMonth()];

  return `${startDay} ${startMonth} – ${endDay} ${endMonth}`;
}

// formatRelativeTimestamp(timestamp)
// Принимает timestamp (в сек или мс).
// Если прошло < 24 часов — возвращает "15 мин", "2 ч", "3 мин" и т.п.
// Если прошло >= 24 часов — возвращает "24 дек", "5 мая" и т.п.
export function formatRelativeTimestamp(inputIso, now = Date.now()) {
  const ts = new Date(inputIso).getTime();
  const diff = now - ts;

  const second = 1000;
  const minute = 60 * second;
  const hour = 60 * minute;
  const day = 24 * hour;

  if (diff < day) {
    if (diff < minute) {
      const secs = Math.floor(diff / second);
      return `${secs}c`;
    }
    const mins = Math.floor(diff / minute);
    if (mins < 60) return `${mins}м`;
    const hours = Math.floor(diff / hour);
    return `${hours}ч`;
  }

  const date = new Date(ts);
  const months = ["янв","фев","мар","апр","мая","июн","июл","авг","сен","окт","ноя","дек"];
  return `${date.getDate()} ${months[date.getMonth()]}.`;
}


//1мин, 1ч, 2 дня, 2 месяца, 1г
export function timeAgoShort(dateInput) {
  let date;

  // Преобразуем входные данные в объект Date
  if (typeof dateInput === 'string') {
    date = new Date(dateInput); // UTC-строка
  } else if (typeof dateInput === 'number') {
    // Проверяем, в миллисекундах или секундах
    date = dateInput > 1e12 ? new Date(dateInput) : new Date(dateInput * 1000);
  } else {
    return '';
  }

  const now = new Date();
  const diffMs = now - date;
  const diffMin = Math.floor(diffMs / (1000 * 60));

  if (diffMin < 60) return `${diffMin}мин`; // минуты

  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH}ч`; // часы

  const diffD = Math.floor(diffH / 24);
  if (diffD < 30) return `${diffD} ${(() => {
    // Склонение дней
    if (diffD % 10 === 1 && diffD % 100 !== 11) return 'день';
    if ([2,3,4].includes(diffD % 10) && ![12,13,14].includes(diffD % 100)) return 'дня';
    return 'дней';
  })()}`; // дни

  const diffM = Math.floor(diffD / 30);
  if (diffM < 12) return `${diffM} ${(() => {
    // Склонение месяцев
    if (diffM % 10 === 1 && diffM % 100 !== 11) return 'месяц';
    if ([2,3,4].includes(diffM % 10) && ![12,13,14].includes(diffM % 100)) return 'месяца';
    return 'месяцев';
  })()}`; // месяцы

  const diffY = Math.floor(diffD / 365);
  return `${diffY}г`; // годы
}

//1мин, 1ч, 2 дня, 2 месяца, 1г (время от заданной точки)
export function timeDiffShort(toDate, fromDate) {
  const to = new Date(toDate);
  const from = new Date(fromDate);

  const diffMs = to - from;
  if (diffMs <= 0) return '0мин';

  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 60) return `${diffMin}мин`;

  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH}ч`;

  const diffD = Math.floor(diffH / 24);
  if (diffD < 30) return plural(diffD, 'день', 'дня', 'дней');

  const diffM = Math.floor(diffD / 30);
  if (diffM < 12) return plural(diffM, 'месяц', 'месяца', 'месяцев');

  return `${Math.floor(diffD / 365)}г`;
}

function plural(n, one, few, many) {
  return `${n} ${
    n % 10 === 1 && n % 100 !== 11
      ? one
      : [2,3,4].includes(n % 10) && ![12,13,14].includes(n % 100)
      ? few
      : many
  }`;
}


//20.10.2025
export function formatUTCDateToDMY(utcDateString) {
  const date = new Date(utcDateString);
  
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date string');
  }
  
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  
  return `${day}.${month}.${year}`;
}

//Июнь 2025
export function formatMonthYear(timestamp) {
  const date = new Date(timestamp);

  const months = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
  ];

  const monthName = months[date.getMonth()];
  const year = date.getFullYear();

  return `${monthName} ${year}`;
}